import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;

    .gauge-input-item {
        margin-bottom: 10px;
    }
    .gauge-input-item .gauge-input-item-two-columns {
        display: flex;
        justify-content: space-between;
        div:nth-child(1) {
            width: 65%;
        }
        div:nth-child(2) {
            width: 35%;
        }
    }
    .gauge-input-item .gauge-input-item-three-columns {
        display: flex;
        justify-content: space-between;
    }
    .gauge-input-item .config-form .helper-tooltip-info,
    .gauge-input-item .config-form .helper-tooltip-divider,
    .gauge-input-item .config-form .helper-tooltip-gradient,
    .gauge-input-item .input-container .tooltip-info {
        position: relative;
    }
    .gauge-input-item .input-container .tooltip-info:hover::before {
        content: '';
        display: block;
        position: absolute;
        top: -15px;
        left: 43px;
        width: 10px;
        height: 10px;
        transform: rotate(45deg);
        background: #000;
    }
    .gauge-input-item .input-container .tooltip-info:hover::after {
        content: 'Use #{VARIABLE} to get variable defined in query pipes.';
        position: absolute;
        display: block;
        top: -50px;
        left: 0;

        min-width: 200px;
        min-height: 40px;

        padding: 4px;

        background: #000;
        color: #fff;
        border: none;
        border-radius: 2px;

        text-align: center;
        z-index: 9999;
    }
    .gauge-input-item .config-form .helper-tooltip-divider:hover::before,
    .gauge-input-item .config-form .helper-tooltip-gradient:hover::before,
    .gauge-input-item .config-form .helper-tooltip-info:hover::before {
        content: '';
        display: block;
        position: absolute;
        top: -15px;
        left: 72px;
        width: 10px;
        height: 10px;
        transform: rotate(45deg);
        background: #000;
    }
    .gauge-input-item .config-form .helper-tooltip-divider:hover::after,
    .gauge-input-item .config-form .helper-tooltip-gradient:hover::after,
    .gauge-input-item .config-form .helper-tooltip-info:hover::after {
        position: absolute;
        display: block;
        top: -80px;
        left: 0;

        min-width: 200px;
        min-height: 70px;

        padding: 4px;

        background: #000;
        color: #fff;
        border: none;
        border-radius: 2px;

        text-align: center;
        z-index: 9999;
    }
    .gauge-input-item .config-form .helper-tooltip-info:hover::after {
        content: 'Use this option to create a range of 3 colors, choosing how many percent each color will fill.';
    }
    .gauge-input-item .config-form .helper-tooltip-divider:hover::after {
        content: 'Show limit to change color';
        min-height: 40px;
        top: -50px;
    }
    .gauge-input-item .config-form .helper-tooltip-gradient:hover::after {
        content: 'Merge colors to a gradient';
        min-height: 40px;
        top: -50px;
    }
`

export const InputText = styled.input`
    width: 100%;
`
